// assets
import { IconKey, IconUsers, IconBoxMultiple, IconClipboardData, IconFileCheck, IconSettings, IconDashboard } from '@tabler/icons';
import { ReactComponent as IconHome } from 'assets/images/icons/ga-home.svg';
import { ReactComponent as IconCalificacion } from 'assets/images/icons/g-calificaciones.svg';
// import { ReactComponent as IconDashboard } from 'assets/images/icons/g-dashboard.svg';
import { ReactComponent as IconEngrane } from 'assets/images/icons/engrane.svg';
import {
    Settings,
    Dashboard,
    FaceRetouchingOff,
    QueryStats,
    RepeatOn,
    DoorSliding,
    DoorBack,
    AutoStories,
    ConnectWithoutContact,
    Diversity3,
    CollectionsBookmark,
    CheckBox,
    Assignment,
    CircleNotifications
} from '@mui/icons-material';

// constant
const icons = {
    tra: IconKey,
    traAdmin: Diversity3,
    ctl: CollectionsBookmark,
    homeIni: IconHome,
    clfClb: CheckBox,
    das: Dashboard,
    config: Settings,
    rep: Assignment,
    btnIncog: FaceRetouchingOff,
    efe: QueryStats,
    dnc: RepeatOn,
    intIni: DoorSliding,
    intEsp: DoorBack,
    cursGene: AutoStories,
    notifi: CircleNotifications,
    traiMade: ConnectWithoutContact
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = (rutas) => {
    const paginas = [];
    rutas.forEach((pagina) => {
        if (pagina.idPadre) {
            const indicePagina = paginas.map((pagina) => pagina.id).indexOf(pagina.idPadre);
            if (indicePagina >= 0)
                paginas[indicePagina].children?.push({
                    id: pagina.idpagina,
                    title: pagina.npagina,
                    type: 'item',
                    icon: icons[pagina.idpagina],
                    url: pagina.raiz === '0' ? pagina.rutaPadre + pagina.ruta : '/'
                });
            else
                paginas.push({
                    id: pagina.idPadre,
                    title: pagina.ncategoria,
                    type: 'collapse',
                    icon: icons[pagina.idPadre],
                    children: [
                        {
                            id: pagina.idpagina,
                            title: pagina.npagina,
                            type: 'item',
                            icon: icons[pagina.idpagina],
                            url: pagina.raiz === '0' ? pagina.rutaPadre + pagina.ruta : '/'
                        }
                    ]
                });
        } else
            paginas.push({
                id: pagina.idpagina,
                title: pagina.npagina,
                type: 'item',
                icon: icons[pagina.idpagina],
                url: pagina.raiz === '0' ? pagina.ruta : '/',
                breadcrumbs: true
            });
    });
    return {
        id: 'pages',
        title: 'MENÚ',
        caption: '',
        type: 'group',
        children: paginas
    };
};

export default pages;
